export default "__VITE_ASSET__CxOfDU6k__"